import { FEATURE_TOUR_SESSION_KEYS } from "../../constants/global.constants";
import { getItemSession, saveItemSession } from "../../utils/session";
import { featureTourSteps } from "./featureTour.config";

export const extractCompletedFeatureTourList = (tourStatus) => {
  if (Array.isArray(tourStatus)) {
    return tourStatus
      .filter((item) => item?.completed)
      .map((item) => item?.feature_key)
      .filter(Boolean);
  }
  return [];
};

export const cacheCompletedFeatureTourList = (featureTours = []) => {
  const uniqueCompletedTours = [...new Set(featureTours.filter(Boolean))];
  saveItemSession(
    FEATURE_TOUR_SESSION_KEYS.COMPLETED_LIST,
    JSON.stringify(uniqueCompletedTours),
  );
  return uniqueCompletedTours;
};

export const isFeatureTourCompleted = (feature) => {
  const cachedValue = getItemSession(FEATURE_TOUR_SESSION_KEYS.COMPLETED_LIST);
  const completedList = cachedValue ? JSON.parse(cachedValue) : [];
  return isFeatureLive(feature) && completedList.includes(feature);
};

export const isFeatureLive = (
  feature,
  featureListString = process.env.REACT_APP_LIVE_FEATURE_LIST,
) => {
  return featureListString.includes(feature);
};

export const getFeatureTourSteps = (t, feature, currentPage) => {
  const steps = featureTourSteps(t, currentPage)?.[feature] || [];
  return steps;
};
